import { render, staticRenderFns } from "./ScrollTopBtn.vue?vue&type=template&id=a9c43864"
import script from "./ScrollTopBtn.vue?vue&type=script&lang=js"
export * from "./ScrollTopBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports